/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import "react-tabs/style/react-tabs.css";

import _ from "lodash";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Button, Card, Col, Form, Modal, Row, Table} from "react-bootstrap";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {FmlxChip} from "fmlx-common-ui";
import * as BiIcon from "react-icons/bi";
import {Get, Post} from "../../lib/Request";
import {
  API_ACTION,
  API_EMPLOYEE_REVIEW,
  API_EMPLOYEE_REVIEW_ENSURE_SELF_REVIEW,
  API_EMPLOYEE_REVIEW_TABLE,
  API_PROJECT_LEADS,
  API_TEAM_PROJECT_DEPT_CURRENT_EMPLOYEE,
  API_TEAM_PROJECT_EMPLOYEE_PERIODS,
  API_TEAM_PROJECT_EMPLOYEE_REVIEW_ASSIGNMENTS,
} from "../../const/Api";
import {FMLX_CHIP} from "../../const/FmlxComponentEnum";
import {ALERT_VARIANT, ETeamRole, REVIEW_TYPE} from "../../const/dataEnum";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import LoadingComponent from "../../components/LoadingComponent";

const defaultProject = {
  id: 0,
  projectName: "-",
};

// const defaultSelectedEmployee = {
//   id: 0,
//   fullName: "-",
// };

export default function ReviewAssignment() {
  const dispatch = useDispatch();
  const {user} = useSelector((state) => ({
    user: state.appState.user,
  }));

  const [loadingPeriod, setLoadingPeriod] = useState(true);
  const [periodList, setPeriodList] = useState([]);
  const [selectedPeriodId, setSelectedPeriodId] = useState(2021);

  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState(defaultProject);

  const [employeeReviews, setEmployeeReview] = useState([]);
  const [selectedEmployeeReviews, setSelectedEmployeeReview] = useState({});

  const [loading, setLoading] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalRegister, setModalRegister] = useState(false);
  const [loadingModify, setLoadingModify] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [selectedEmployeeTeamRole, setSelectedEmployeeTeamRole] = useState({});
  const [employeeLists, setEmployeeList] = useState([]);
  const [employeeListAssignment, setEmployeeListAssignment] = useState([]);

  const [statusOptions, setStatusOptions] = useState([
    {value: "", label: "Select status"},
    {value: "all", label: "All"},
    {value: "done", label: "Done"},
    {value: "ongoing", label: "Ongoing"},
  ]);

  const [loadingQueryEmployeeReviews, setLoadingQueryEmployeeReviews] = useState(false);
  const [queryEmployeeReviewsList, setQueryEmployeeReviewsList] = useState(null);
  const [selectedStatusQuery, setSelectedStatusQuery] = useState(null);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      fetchProjects();
    }

    return function cleanup() {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedStatusQuery && selectedPeriodId) {
      queryEmployeeReviews(selectedStatusQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatusQuery, selectedPeriodId]);

  async function fetchProjects() {
    let result = await Get(API_PROJECT_LEADS);

    if (!errorShowMessage(result)) {
      setProjectList(result.data);
      let initialProjectSelection = result.data[0];
      setSelectedProject(initialProjectSelection);
      fetchEmployeeProjectYears(initialProjectSelection.id);
    }
  }

  function errorShowMessage(result) {
    if (result.responseCode !== 0 && result.responseCode !== -10) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: result.message,
        })
      );
      return true;
    }

    return false;
  }

  async function fetchEmployeeProjectYears(projectId) {
    setLoadingPeriod(true);

    let result = await Get(API_TEAM_PROJECT_EMPLOYEE_PERIODS.replace("{PROJECT_ID}", projectId));
    setPeriodList(result.data);

    if (!errorShowMessage(result)) {
      let initialPeriod = result.data[result.data.length - 1];
      setSelectedPeriodId(initialPeriod.id);
      fetchEmployeeReview(projectId, initialPeriod.id);
    }

    setLoadingPeriod(false);
  }

  async function fetchEmployeeReview(projectId, periodId) {
    setLoading(true);
    let result = await Get(
      API_TEAM_PROJECT_EMPLOYEE_REVIEW_ASSIGNMENTS.replace("{PROJECT_ID}", projectId).replace("{PERIOD_ID}", periodId)
    );
    let listEmployee = await Get(
      API_TEAM_PROJECT_DEPT_CURRENT_EMPLOYEE.replace("{PROJECT_ID}", projectId).replace("{DEPT_ID}", user?.departmentID)
    );
    setEmployeeList(
      listEmployee?.data?.map((element) => {
        return {...element, selected: false};
      })
    );
    setEmployeeReview(result.data);
    setLoading(false);
  }

  async function queryEmployeeReviews(status) {
    if (status === "") {
      return;
    } else {
      if (selectedStatusQuery === null) {
        setStatusOptions([statusOptions[1], statusOptions[2], statusOptions[3]]);
      }
    }

    setLoadingQueryEmployeeReviews(true);

    //let result = await Get(API_EMPLOYEE_REVIEW_TABLE + `/${status}`);
    let result = await Get(API_EMPLOYEE_REVIEW_TABLE + `/${status}/${selectedPeriodId}`);
    errorShowMessage(result);
    if (result.responseCode === 0) {
      setQueryEmployeeReviewsList(result.data);
    } else {
      setQueryEmployeeReviewsList([]);
    }
    setLoadingQueryEmployeeReviews(false);
  }

  async function ensureAllSelfReviewsAreAssigned(periodId) {
    let result = await Get(API_EMPLOYEE_REVIEW_ENSURE_SELF_REVIEW + `/${periodId}`);
    if (result.responseCode === 0) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.SUCCESS,
          message: `Self Review Assignment ${periodList.find((p) => p.id === periodId).period} created successfully`,
        })
      );
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: `Self Review Assignment ${periodList.find((p) => p.id === periodId).period} failed to be created`,
        })
      );
    }
  }

  function registerClose() {
    var temp = _.cloneDeep(employeeLists).map((element) => {
      return {...element, selected: false};
    });
    setEmployeeList(temp);
    setEmployeeListAssignment([]);
    setModalRegister(false);
  }

  async function deleteReviewAssignment() {
    setLoadingModify(true);
    let result = await Post(API_EMPLOYEE_REVIEW + API_ACTION.DELETE, {
      id: selectedEmployeeReviews.id,
      projectID: selectedEmployeeReviews.projectID,
      reviewTypeID: selectedEmployeeReviews.reviewTypeID,
    });
    if (result.responseCode === 0) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.SUCCESS,
          message: "Review Assignment Deleted Successfully",
        })
      );
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: "Failed when Deleting Review Assignment",
        })
      );
    }
    fetchEmployeeReview(selectedProject.id, selectedPeriodId);
    setLoadingModify(false);
    setModalDelete(false);
  }

  function registerReview(employee) {
    setModalRegister(true);
    var tempEmployeeList = _.cloneDeep(employeeLists).filter((element) => {
      var notRegistered = true;
      if (employee !== null) {
        if (employee.myReviews.length > 0) {
          employee.myReviews.map((el) => {
            if (element.employeeID === el.employeeReviewedID && el.reviewedByID === employee.id) notRegistered = false;
          });
        }
      }
      return notRegistered;
    });

    setEmployeeListAssignment(tempEmployeeList);
  }

  async function saveRegisterReview() {
    setLoadingModify(true);
    var param = [];

    employeeListAssignment.forEach((element) => {
      if (element.selected) {
        param.push({
          id: 0,
          employeeReviewedID: element.employeeID,
          reviewedByID: selectedEmployee.id,
          reviewTypeID:
            element.employeeID === selectedEmployee.id
              ? REVIEW_TYPE.SELF.Id
              : selectedEmployeeTeamRole === ETeamRole.TEAM_LEADER || selectedEmployeeTeamRole === ETeamRole.PRACTICE_LEADER
                ? REVIEW_TYPE.MANAGER.Id
                : REVIEW_TYPE.PEER.Id,
          reviewPeriodID: selectedPeriodId,
          reviewDate: null,
          projectID: selectedProject.id,
        });
      }
    });

    let result = await Post(API_EMPLOYEE_REVIEW + API_ACTION.CREATE + API_ACTION.BATCH, param);
    if (result.responseCode === 0) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.SUCCESS,
          message: "Success",
        })
      );
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: "Failed",
        })
      );
    }
    fetchEmployeeReview(selectedProject.id, selectedPeriodId);
    setLoadingModify(false);
    setModalRegister(true);
    registerClose();
  }

  const projectSelect = (
    <div className="col-2">
      <label htmlFor="selectPeriod" className="label">
        Project
      </label>
      <select
        id="selectProject"
        className="form-select"
        aria-label="Select Project"
        value={selectedProject.id}
        onChange={(e) => {
          let chosenProject = projectList[e.target.selectedIndex];
          setSelectedProject(chosenProject);
          fetchEmployeeProjectYears(chosenProject.id);
        }}
      >
        {projectList?.map((project, index) => (
          <option key={project.id} value={project.id}>
            {project.projectName}
          </option>
        ))}
      </select>
    </div>
  );

  const autoAssignSelfReviews = (
    <div className="col-4">
      {user?.authRole?.role === "Manager" ? (
        <Button
          style={{whiteSpace: "nowrap", marginTop: "23px"}}
          variant="outline-danger"
          onClick={() => {
            ensureAllSelfReviewsAreAssigned(selectedPeriodId);
          }}
        >
          Assign ALL self reviews - managers only <BiIcon.BiPlusCircle/>
        </Button>
      ) : (
        ""
      )}
    </div>
  );

  const periodSelect = (
    <div className="col-2">
      <label htmlFor="selectPeriod" className="label">
        Period
      </label>
      <select
        id="selectPeriod"
        className="form-select"
        aria-label="Default select example"
        value={selectedPeriodId}
        onChange={(e) => {
          setSelectedPeriodId(e.target.value);
          fetchEmployeeReview(selectedProject.id, e.target.value);
        }}
      >
        {periodList.map((per) => (
          <option key={per.id} value={per.id}>
            {per.period}
          </option>
        ))}
      </select>
    </div>
  );

  const assignmentSelect = (
    <div className="row mb-4">
      <div className="col-md-12 col-lg-12 col-sm-24">
        <div className="row g-3">
          {projectSelect}
          {/*</div>*/}

          {/*/!*<div className="row g-1">&nbsp;<br/></div>*!/*/}

          {/*<div className="row g-3">*/}
          {periodSelect}
          {autoAssignSelfReviews}
        </div>
      </div>
    </div>
  );

  const assignmentBody = (
    <React.Fragment>
      {loading ? (
        <div className="text-center">
          <LoadingComponent/>
        </div>
      ) : employeeReviews === null || employeeReviews?.length === 0 ? (
        <div className="text-center">No Data Available</div>
      ) : (
        employeeReviews?.map((element, index) => {
          return (
            <Card key={index} className="mb-4">
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <div style={{fontSize: "14px"}}>Reviewer</div>
                    <h4>{element.employee.fullName}</h4>
                    <div className="mb-4" style={{fontSize: "14px"}}>
                      as {element.teamRole + " (" + element.employee.practice.department.departmentName + ")"}
                    </div>
                  </Col>
                  <Col md={6} style={{textAlign: "right"}}>
                    <Button
                      onClick={() => {
                        setSelectedEmployee(element.employee);
                        setSelectedEmployeeTeamRole(element.teamRole);
                        registerReview(element.employee);
                      }}
                    >
                      Assign Reviewees <BiIcon.BiPlusCircle/>
                    </Button>
                  </Col>
                  <Col md={12}>
                    <Table>
                      <thead>
                      <tr>
                        <th style={{width: 40 + "%"}}>Reviewee</th>
                        <th style={{width: 20 + "%"}}>Type</th>
                        <th style={{width: 20 + "%"}}>Status</th>
                        <th style={{width: 20 + "%"}}>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      {element.employee.myReviews.filter(
                        (r) => r.reviewedEmployee?.departmentID === user?.departmentID
                      ).length === 0 ? (
                        <tr>
                          <td className="text-center" colSpan="4">
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        element.employee.myReviews
                          .filter((r) => r.reviewedEmployee?.departmentID === user?.departmentID)
                          .map((el, index) => {
                            return (
                              <tr key={index}>
                                <td>{el.reviewedEmployee.fullName}</td>
                                <td>{el.reviewType.reviewTypeName}</td>
                                <td>
                                  <FmlxChip
                                    variant={FMLX_CHIP.VARIANT.FILLED}
                                    type={el.reviewDate === null ? FMLX_CHIP.TYPE.DEFAULT : FMLX_CHIP.TYPE.SAFE}
                                    label={el.reviewDate === null ? "Not Yet" : "Done"}
                                  />
                                </td>
                                <td className="text-center">
                                  {el.reviewDate === null ? (
                                    <Button
                                      variant="danger"
                                      onClick={() => {
                                        setSelectedEmployeeReview(el);
                                        setModalDelete(true);
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            );
                          })
                      )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          );
        })
      )}

      <Modal centered show={modalDelete} onHide={() => setModalDelete(false)}>
        <Modal.Header>
          <Modal.Title>Delete Review Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to delete this assignment?</Modal.Body>
        <Modal.Footer>
          <Button style={{width: "100px"}} variant="danger" disabled={loadingModify} onClick={deleteReviewAssignment}>
            {loadingModify ? <LoadingComponent/> : "Delete"}
          </Button>
          <Button disabled={loadingModify} variant="secondary" onClick={() => setModalDelete(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal centered show={modalRegister} onHide={() => setModalRegister(false)}>
        <Modal.Header>
          <Modal.Title>Assign Reviewees</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group size="lg" controlId="username" className="mb-2">
            <Form.Label>Reviewer</Form.Label>
            <Form.Control autoFocus placeholder="Question" type="text" readOnly value={selectedEmployee.fullName}/>
          </Form.Group>
          <div className="mt-4 mb-2">Reviewee</div>
          {employeeListAssignment.length === 0 ? (
            <div className="text-center">No Data</div>
          ) : (
            employeeListAssignment.map((per, index) => (
              <Card key={index}>
                <Card.Body>
                  <Row>
                    <Col>
                      {per.employee.fullName}
                      <div style={{fontSize: "12px"}}>{per.teamRole}</div>
                    </Col>
                    <Col style={{textAlign: "right"}}>
                      <Form.Check
                        inline
                        label=""
                        name="group1"
                        type="checkbox"
                        checked={per.selected}
                        onChange={(e) => {
                          var temp = _.cloneDeep(employeeListAssignment);
                          temp[index].selected = e.target.checked;
                          setEmployeeListAssignment(temp);
                        }}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{width: "100px"}}
            variant="primary"
            disabled={loadingModify || employeeListAssignment.length === 0}
            onClick={saveRegisterReview}
          >
            {loadingModify ? <LoadingComponent/> : "Save"}
          </Button>
          <Button disabled={loadingModify} variant="secondary" onClick={registerClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );

  const employeeReviewsStatusSelect = (
    <div className="col-2">
      <label htmlFor="selectPeriod" className="label">
        Status
      </label>
      <select
        id="selectStatus"
        className="form-select"
        aria-label="Select status"
        value={selectedStatusQuery}
        onChange={(e) => {
          setSelectedStatusQuery(e.target.value);
          queryEmployeeReviews(e.target.value);
        }}
      >
        {statusOptions.map((statusOption, index) => (
          <option key={statusOption.value} value={statusOption.value}>
            {statusOption.label}
          </option>
        ))}
      </select>
    </div>
  );

  const employeeReviewsBody = (
    <div>
      {loadingQueryEmployeeReviews ? (
        <div className="text-center">
          <LoadingComponent/>
        </div>
      ) : queryEmployeeReviewsList === null ? (
        <div className="text-center">
          <br/>
          Please select the review status you want to query
          <br/>
          <br/>
        </div>
      ) : queryEmployeeReviewsList && queryEmployeeReviewsList.length === 0 ? (
        <div className="text-center">
          <br/>
          No Data Available
          <br/>
          <br/>
        </div>
      ) : (
        <Table>
          <thead>
          <tr>
            <th>
              {queryEmployeeReviewsList.length} found
              <br/>
              <br/>
            </th>
          </tr>
          <tr>
            <th style={{width: 80 / 3 + "%"}}>Reviewer</th>
            <th style={{width: 80 / 3 + "%"}}>Reviewee</th>
            <th style={{width: 80 / 3 + "%"}}>Leaders</th>
            <th style={{width: 10 + "%"}}>Type</th>
            <th style={{width: 10 + "%"}}>Status</th>
          </tr>
          </thead>
          <tbody>
          {queryEmployeeReviewsList.map((employeeReview, index) => (
            <tr>
              <td>{employeeReview.reviewer}</td>
              <td>{employeeReview.reviewee}</td>
              <td>
                <div>
                  {employeeReview.leaders?.map((leader, index) => (
                    <div>{leader}</div>
                  ))}
                </div>
              </td>
              <td>{employeeReview.type}</td>
              <td>
                {employeeReview.status === "ongoing" ? (
                  <Badge bg="secondary">Ongoing</Badge>
                ) : (
                  <Badge bg="success">Done</Badge>
                )}
              </td>
            </tr>
          ))}
          </tbody>
        </Table>
      )}
    </div>
  );

  return (
    <div className="container">
      {user?.authRole?.role === "Manager" ? (
        <Tabs>
          <TabList>
            <Tab>Assignment</Tab>
            <Tab>Query</Tab>
          </TabList>

          <TabPanel
            style={{
              marginTop: "-10px",
              padding: 10 + "px",
              border: "1px solid #aaa",
              borderTop: "none",
            }}
          >
            {assignmentSelect}
            {assignmentBody}
          </TabPanel>

          <TabPanel
            style={{
              marginTop: "-10px",
              padding: 10 + "px",
              borderLeft: "1px solid #aaa",
              borderRight: "1px solid #aaa",
              borderBottom: "1px solid #aaa",
              borderTop: "none",
            }}
          >
            <div className="row mb-4">
              <div className="col-md-12 col-lg-12 col-sm-24">
                <div className="row g-3">
                  {periodSelect}
                  {employeeReviewsStatusSelect}
                </div>
              </div>
            </div>
            {employeeReviewsBody}
          </TabPanel>
        </Tabs>
      ) : (
        <div>
          {assignmentSelect}
          {assignmentBody}
        </div>
      )}
    </div>
  );
}
